import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  MenuItem,
  Grid,
} from "@mui/material";
import axios from "axios"; // Import Axios
import { getToken, base_url } from "../../config/config";

const TaskLogger = () => {
  const location = useLocation();
  const { employeeName, checkInTime } = location.state || {};
  const [taskType, setTaskType] = useState("Create an Offer");
  const [taskStartTime, setTaskStartTime] = useState("");
  const [taskEndTime, setTaskEndTime] = useState("");
  const [taskTimeSpent, setTaskTimeSpent] = useState("");
  const [description, setDescription] = useState("");

  const [startTime, setStartTime] = useState(checkInTime || ""); // Check-in time
  const [endTime, setEndTime] = useState(""); // Check-out time

  useEffect(() => {
    if (checkInTime) {
      setStartTime(checkInTime);
    }
  }, [checkInTime]);

  const calculateTimeSpent = (start, end) => {
    const startDate = new Date(`1970-01-01T${start}:00`);
    const endDate = new Date(`1970-01-01T${end}:00`);
    const diffMs = endDate - startDate;
    const diffMins = diffMs / 1000 / 60;
    return diffMins;
  };

  const handleTaskEndTimeChange = (e) => {
    setTaskEndTime(e.target.value);
    const calculatedTime = calculateTimeSpent(taskStartTime, e.target.value);
    if (!isNaN(calculatedTime) && calculatedTime >= 0) {
      setTaskTimeSpent(calculatedTime);
    } else {
      setTaskTimeSpent("");
    }
  };

  const handleCheckOut = async () => {
    const currentTime = new Date().toLocaleTimeString();
    setEndTime(currentTime);
    try {
      const checkInData = {
        user: employeeName,
        checkInTime: startTime,
        checkOutTime: currentTime,
        checkInDate: new Date().toISOString().split("T")[0], // Current date
      };
      const response = await axios.post(
        `${base_url}/v1/createCheckIn`,
        checkInData,
      ); // Replace with your actual API endpoint

      if (response.status === 201) {
        alert("Checked out successfully!");
      }
    } catch (error) {
      console.error("Error checking out:", error);
      alert("Failed to check out. Please try again.");
    }
  };

  const handleTaskLog = async () => {
    try {
      const taskData = {
        user: employeeName, // Assuming employeeName is the user
        type: taskType,
        startTime: taskStartTime,
        endTime: taskEndTime,
        totalTime: `${taskTimeSpent} minutes`,
        description: description,
      };

      const response = await axios.post(`${base_url}/v1/TaskLog`, taskData); // Replace with your actual API endpoint

      if (response.status === 201) {
        alert("Task logged successfully!");
        // Optionally, reset form fields or handle other UI updates
      }
    } catch (error) {
      console.error("Error logging task:", error);
      alert("Failed to log task. Please try again.");
    }
  };

  return (
    <Container maxWidth='md'>
      <Grid container spacing={4} sx={{ mt: 4 }}>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              p: 4,
              borderRadius: 2,
              boxShadow: 3,
              backgroundColor: "#f9f9f9",
            }}>
            <Typography variant='h6' gutterBottom>
              Task Logger
            </Typography>
            <TextField
              select
              label='Task Type'
              variant='outlined'
              fullWidth
              margin='normal'
              value={taskType}
              onChange={(e) => setTaskType(e.target.value)}>
              <MenuItem value='Create an Offer'>Create an Offer</MenuItem>
              <MenuItem value='Construction / Measurement'>
                Construction / Measurement
              </MenuItem>
              <MenuItem value='Training with Mr.Wilfry Büttner'>
                Training with Mr.Wilfry Büttner
              </MenuItem>
              <MenuItem value='Other'>Other</MenuItem>
            </TextField>
            <TextField
              label='Task Start Time'
              type='time'
              variant='outlined'
              fullWidth
              margin='normal'
              InputLabelProps={{
                shrink: true,
              }}
              value={taskStartTime}
              onChange={(e) => setTaskStartTime(e.target.value)}
            />
            <TextField
              label='Task End Time'
              type='time'
              variant='outlined'
              fullWidth
              margin='normal'
              InputLabelProps={{
                shrink: true,
              }}
              value={taskEndTime}
              onChange={handleTaskEndTimeChange}
            />
            <TextField
              label='Task Time Spent (minutes)'
              type='number'
              variant='outlined'
              fullWidth
              margin='normal'
              value={taskTimeSpent}
              InputProps={{
                readOnly: true,
              }}
            />
            <TextField
              label='Description'
              variant='outlined'
              multiline
              rows={4}
              fullWidth
              margin='normal'
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            <Button
              variant='contained'
              color='secondary'
              fullWidth
              onClick={handleTaskLog}
              sx={{
                mt: 2,
                p: 1.5,
                fontSize: "16px",
              }}>
              Log Task
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              p: 4,
              borderRadius: 2,
              boxShadow: 3,
              backgroundColor: "#f9f9f9",
            }}>
            <Typography variant='h6' gutterBottom>
              Check In/Check Out Time
            </Typography>
            <TextField
              label='Check-In Time'
              type='time'
              variant='outlined'
              fullWidth
              margin='normal'
              InputLabelProps={{
                shrink: true,
              }}
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />
            <TextField
              label='Check-Out Time'
              type='time'
              variant='outlined'
              fullWidth
              margin='normal'
              InputLabelProps={{
                shrink: true,
              }}
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
            <Button
              variant='contained'
              color='primary'
              fullWidth
              onClick={handleCheckOut}
              sx={{
                mt: 2,
                p: 1.5,
                fontSize: "16px",
              }}>
              Check Out
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default TaskLogger;
